import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';
import { Store } from '../../../Store';
import { getError } from '../../../utils';

import Modal from 'react-bootstrap/Modal';
import './css/login.css';
import SignIn from './compoment/SignIn';
import SignUp from './compoment/SignUp';
import RegisterSuccess from './compoment/RegisterSuccess';
import ForgotPass from './compoment/ForgotPassWord';
import OTPInput from './compoment/OTPInput';
import ChangePass from './compoment/ChangePass';

export default function ModalLogin(props) {
  const { dispatch: ctxDispatch } = useContext(Store);
  const location = useLocation();

  const [redirect, setRedirect] = useState(false);
  const [success, setSuccess] = useState(false);
  const [forgotPass, setForgotPass] = useState(false);
  const [showOTPInput, setShowOTPInput] = useState(false);
  const [changePass, setChangePass] = useState(false);
  const [codeOTP, setCodeOTP] = useState('');

  useEffect(() => {
    if (props.show) {
      setRedirect(false);
      setSuccess(false);
      setForgotPass(false);
      setShowOTPInput(false);
      setChangePass(false);
    }
    if (props.isUserInfo) {
      setRedirect(true);
    }
  }, [props.show, props.isUserInfo]);

  const handleRedirect = () => setRedirect((prev) => !prev);

  const handleClose = () => {
    props.onHide();
  };

  const redirectHandler = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.get('/customer/auth/google/redirect');
      ctxDispatch({ type: 'PREV-LINK', payload: location.pathname });
      localStorage.setItem('resentLink', JSON.stringify(location.pathname));
      window.location.href = data.data;
    } catch (err) {
      toast.error(getError(err));
    }
  };

  const handleOTPSubmit = useCallback((otpCode) => {
    setCodeOTP(otpCode); // cập nhật state hoặc gọi API tùy ý
  }, []);

  const handleChangePass = useCallback(() => {
    setChangePass(true);
  }, []);

  const handlePrev = () => {
    setChangePass(false);
    setShowOTPInput(true);
  };

  return (
    <div className="modal-login">
      <Modal
        {...props}
        size={!success ? (redirect ? 'lg' : 'md') : 'sm'}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
      >
        <Modal.Body>
          {!success && (
            <button className="close close-color" onClick={handleClose}>
              <i className="fas fa-times"></i>
            </button>
          )}

          {!success ? (
            <section className="container-login">
              {changePass ? (
                <div className="text-center">
                  <div className="otp-icon-wrapper">
                    <svg
                      className="otp-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                  </div>
                  <h2 className="otp-title">Thay đổi mật khẩu</h2>
                  <p>Thay đổi mật khẩu mới của bạn</p>
                </div>
              ) : showOTPInput ? (
                <div className="text-center">
                  <div className="otp-icon-wrapper">
                    <svg
                      className="otp-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                  </div>
                  <h2 className="otp-title">Xác thực OTP</h2>
                  <p>Nhập mã xác thực 6 chữ số đã được gửi đến email của bạn</p>
                </div>
              ) : forgotPass ? (
                <div className="forgotpass-header">
                  <div className="forgotpass-icon-wrapper">
                    <svg
                      className="forgotpass-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                      />
                    </svg>
                  </div>
                  <h2 className="forgotpass-title">Quên mật khẩu?</h2>
                  <p>
                    Điền email gắn với tài khoản của bạn để nhận đường dẫn thay
                    đổi mật khẩu.
                  </p>
                </div>
              ) : redirect ? (
                <h2
                  className="text-center default-box-title mb-0"
                  style={{
                    color: props.isUserInfo && 'var(--color-second)',
                  }}
                >
                  {props.isUserInfo
                    ? 'Thông tin cá nhân'
                    : 'Thông tin Đăng ký thành viên'}
                </h2>
              ) : (
                <h2 className="text-center default-box-title">Đăng nhập</h2>
              )}

              <article className=" scroll-register">
                {changePass ? (
                  <ChangePass
                    handleClose={handleClose}
                    handlePrev={handlePrev}
                    codeOTP={codeOTP}
                  />
                ) : showOTPInput ? (
                  <OTPInput
                    onSubmitOTP={handleOTPSubmit}
                    onChangePass={handleChangePass}
                  />
                ) : forgotPass ? (
                  <ForgotPass
                    onHome={() => setForgotPass(false)}
                    onOTP={() => setShowOTPInput(true)}
                  />
                ) : redirect ? (
                  <SignUp
                    onClose={() => setSuccess(true)}
                    close={handleClose}
                    isUserInfo={props.isUserInfo}
                  />
                ) : (
                  <SignIn onForgotPass={() => setForgotPass(true)} />
                )}

                {!forgotPass && !props.isUserInfo && (
                  <aside>
                    <div className="login-with-google mb-3">
                      <div className="border-line d-flex justify-content-center align-items-center mb-3">
                        <div className="line"></div>
                        <div className="line-text">HOẶC</div>
                        <div className="line"></div>
                      </div>
                      <div className="d-flex justify-content-center align-items-center">
                        <button
                          onClick={redirectHandler}
                          className="d-flex justify-content-center align-items-center"
                        >
                          {`${redirect ? 'Đăng ký' : 'Đăng nhập'} với Google`}{' '}
                          <img
                            src="/images/icons/google-logo.png"
                            alt={`${
                              redirect ? 'Đăng ký' : 'Đăng nhập'
                            } với Google`}
                          />
                        </button>
                      </div>
                    </div>

                    <p className="text-center m-0">
                      <span>{`Bạn ${
                        redirect ? 'đã' : 'chưachưa'
                      } có tài khoản? `}</span>
                      <span
                        className="registration-redirect"
                        onClick={handleRedirect}
                      >
                        {`${redirect ? 'Đăng nhập' : 'Đăng ký'}`}
                      </span>
                    </p>
                  </aside>
                )}
              </article>
            </section>
          ) : (
            <RegisterSuccess onClose={handleClose} />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
